export default __webpack_public_path__ + "images/TP.24a3750.png";